"use client";

import TermsView from "@/views/TermsOfService";

export default function TermsPage() {
  return <TermsView />;
}
